<template>
  <div class="app-footer">
    <div class="container">
      <div class="app-footer__row flex">
        <p><i class="fas fa-code-branch" style="margin-right: 5px;; font-size: 11px;"></i> Ver {{ buildInfo.buildDate }}
          <a href="https://fast.com" target="_blank" style="color:white;margin-left: 35px;">SpeedTest</a>
          <router-link to="/admin/feedback" style="color:white;margin-left: 35px;">Feedback</router-link>
        </p>
        <div  v-if ="servernetwork =='slow' && !servernetworkFailure" class="flex">
          <p class="deadnet"> <span style="font-size: 13px;">&#9888;</span> Console API Slow</p> &nbsp;&nbsp;&nbsp; <div class="led-yellow"></div>
        </div>

        <div  v-if ="servernetwork =='fast' && servernetworkFailure" class="flex">
          <p class="deadnet"> <span style="font-size: 13px;">&#9888;</span> Console API Disconnected</p> &nbsp;&nbsp;&nbsp; <div class="led-red"></div>
        </div>

        <div  v-if ="network =='slow' && !networkFailure" class="flex">
          <p class="deadnet"> <span style="font-size: 13px;">&#9888;</span> Network Slow</p> &nbsp;&nbsp;&nbsp; <div class="led-yellow"></div>
        </div>

        <div  v-if ="network =='fast' && networkFailure" class="flex">
          <p class="deadnet"> <span style="font-size: 13px;">&#9888;</span> Network Disconnected</p> &nbsp;&nbsp;&nbsp; <div class="led-red"></div>
        </div>

        <div  v-if ="liveRunSpeakerAPIFail" class="flex">
          <p class="deadnet"> <span style="font-size: 13px;">&#9888;</span> LiveRun Speaker API Down</p> &nbsp;&nbsp;&nbsp; <div class="led-red"></div>
        </div>

        <div>
          <p> <router-link to="/admin/active-run"  style="color:white">Active Run : {{activeRun}}</router-link></p>
        </div>

        <!-- LiveRun Bot Indicator - Always visible and clickable -->
        <div class="flex auto-pilot-indicator">
          <p class="deadnet">
            <span class="robot-icon" :class="{'animate-robot': isStartingSoon}">
              <i class="fas fa-robot"></i>
            </span>
            LiveRun Bot:
            <span v-if="nextAutoPilotRun">
              <span class="autopilot-run" @click="goToRace(nextAutoPilotRun.raceId)">
                {{nextAutoPilotRun.name}}
              </span>
              <span class="countdown">({{formatTimeRemaining}})</span>
              <span class="autopilot-message">- This run is being handled in autopilot mode</span>
            </span>
            <span v-else class="no-runs">No upcoming runs in next 5 days on AutoPilot</span>
          </p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
import axios from 'axios'
import buildInfo from '@/build-info.json'
  export default {
    name: 'AppFooter',
    data: () => ({
      networkInterval:null,
      count:0,
      available:true,
      networkFailure:false,
      network:'',
      servercount:0,
      serveravailable:true,
      servernetworkFailure:false,
      liveRunSpeakerAPIFail:false,
      servernetwork:'',
      activeRun:0,
      nextAutoPilotRun: null,
      autoPilotCheckInterval: null,
      buildInfo,
      expressApiUrls:[
        'https://trainerapi-s1.liverunapp.com:3107/',
        'https://trainerapi-s.liverunapp.com:3105/',
        'https://trainerapi.liverunapp.com:3104/',
        //'http://localhost:3005/'
      ]
    }),
    components: {

    },
    methods:{
     checkNetwork(){
       this.available = false
       this.count = 0

       axios.get('https://jsonplaceholder.typicode.com/todos/1')
            .then(response => {
                this.available = true
                this.networkFailure = false
            },
             error =>{
               this.networkFailure = true
               this.available = true
             }
            )
     },
     checkApiServer(){
       this.serveravailable = false
       this.servercount = 0

       axios.get('https://trainerapi-s1.liverunapp.com:3107/')
            .then(response => {
                this.serveravailable = true
                this.servernetworkFailure = false
            },
             error =>{
               this.servernetworkFailure = true
               this.serveravailable = true
             }
            )
     },
     checkLiveRunSpeakerAPI(){
       this.liveRunSpeakerAPIFail = false
      // axios.get(`http://localhost:3007/utility/isRecorderServiceWorking`)
      axios.get(this.$expressApi+`utility/isRecorderServiceWorking`)
        .then(response => {
           if(response.data){
            this.liveRunSpeakerAPIFail = false
          }else{
            this.liveRunSpeakerAPIFail = true
          }
        })
     },
     getActiveRun(){
       //console.log("expressApiUrls---",this.expressApiUrls)

       this.expressApiUrls.forEach((apiUrl) => {
        //console.log("url---",apiUrl)
        this.activeRun = 0
        const AuthStr = 'Bearer '.concat(window.localStorage.getItem('default-auth-token'))
        axios.get(apiUrl+`active-run-count`, { headers: { Authorization: AuthStr } })
         //axios.get(this.$expressApi+`active-run-count`)
            .then(response => {
              //console.log("activerun---",response.data)
              this.activeRun=this.activeRun+response.data.length
              //console.log("this.activeRun---",this.activeRun)
            },
             error =>{
              console.log("error---",error)
             })

        })

        //const AuthStr = 'Bearer '.concat(window.localStorage.getItem('default-auth-token'))
        //axios.get('http://localhost:3005/active-run-count', { headers: { Authorization: AuthStr } })
        // axios.get(this.$expressApi+`active-run-count`, { headers: { Authorization: AuthStr } })
        //  //axios.get(this.$expressApi+`active-run-count`)
        //     .then(response => {
        //       //console.log("activerun---",response.data)
        //       this.activeRun=response.data.length
        //     },
        //      error =>{
        //       console.log("error---",error)
        //      })
     },
     /**
      * Check for the next auto-pilot run
      * @param {number} days - Number of days to look ahead (default: 5)
      */
     checkNextAutoPilotRun(days = 5) {
       // Ensure the API URL has a trailing slash
      const apiUrl = this.$expressApi.endsWith('/') ? this.$expressApi : this.$expressApi + '/';
      axios.get(apiUrl + 'auto-run/next-run', {
         params: { days: days }
       })
         .then(response => {
           if (response.data.success && response.data.hasNextRun) {
             this.nextAutoPilotRun = response.data.nextRun;
           } else {
             this.nextAutoPilotRun = null;
           }
         })
         .catch(error => {
           console.error('Error fetching next auto-pilot run:', error);
           this.nextAutoPilotRun = null;
         });
     },

     /**
      * Navigate to the race page when clicking on the auto-pilot run in the footer
      * @param {number} raceId - The ID of the race to navigate to
      */
     goToRace(raceId) {
       if (raceId) {
         this.$router.push(`/admin/live-run/race/${raceId}`);
       }
     }
    },
    computed: {
      ...mapGetters({
        template: '#modal-template',
        isAuthenticated: 'auth/isAuthenticated'
      }),
      isStartingSoon() {
        if (!this.nextAutoPilotRun || !this.nextAutoPilotRun.timeToStart) {
          return false;
        }

        const { days, hours, minutes } = this.nextAutoPilotRun.timeToStart;
        // Return true if the run is starting in less than 10 minutes
        return days === 0 && hours === 0 && minutes < 10;
      },

      formatTimeRemaining() {
        if (!this.nextAutoPilotRun || !this.nextAutoPilotRun.timeToStart) {
          return '';
        }

        const { days, hours, minutes, seconds } = this.nextAutoPilotRun.timeToStart;

        // Format based on how far away the run is
        if (days > 0) {
          return `${days}d ${hours}h`;
        } else if (hours > 0) {
          return `${hours}h ${minutes}m`;
        } else if (minutes > 0) {
          return `${minutes}m ${seconds}s`;
        } else {
          return `${seconds}s`;
        }
      }
    },
    created() {
      this.networkInterval = setInterval(() => {
        this.checkNetwork()
        this.checkApiServer()
        this.checkLiveRunSpeakerAPI()
        this.getActiveRun()
      }, 5000)

      // Check for auto-pilot runs every 15 seconds
      this.autoPilotCheckInterval = setInterval(() => {
        this.checkNextAutoPilotRun()
      }, 15000)

      // Initial check for auto-pilot runs
      this.checkNextAutoPilotRun()
    },
    beforeDestroy() {
      console.log("clear intervals")
      clearInterval(this.networkInterval)
      clearInterval(this.autoPilotCheckInterval)
    }
  }
</script>

<style lang="stylus" scoped>
  .app-footer
    background #423799
    padding 10px 0
    position fixed
    left 0
    bottom 0
    width 100%
    color white
    text-align right
</style>
<style>
.led-box {
  height: 30px;
  width: 25%;
  margin: 10px 0;
  float: left;
}

.led-box p {
  font-size: 12px;
  text-align: center;
  margin: 1em;
}

.led-red {
  margin: 0 auto;
  width: 10px;
  height: 10px;
  background-color: #F00;
  border-radius: 50%;
  /* box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #441313 0 -1px 9px, rgba(255, 0, 0, 0.5) 0 2px 12px;
  -webkit-animation: blinkRed 0.5s infinite;
  -moz-animation: blinkRed 0.5s infinite;
  -ms-animation: blinkRed 0.5s infinite;
  -o-animation: blinkRed 0.5s infinite;
  animation: blinkRed 0.5s infinite; */
}

@-webkit-keyframes blinkRed {
    from { background-color: #F00; }
    50% { background-color: #A00; box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #441313 0 -1px 9px, rgba(255, 0, 0, 0.5) 0 2px 0;}
    to { background-color: #F00; }
}
@-moz-keyframes blinkRed {
    from { background-color: #F00; }
    50% { background-color: #A00; box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #441313 0 -1px 9px, rgba(255, 0, 0, 0.5) 0 2px 0;}
    to { background-color: #F00; }
}
@-ms-keyframes blinkRed {
    from { background-color: #F00; }
    50% { background-color: #A00; box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #441313 0 -1px 9px, rgba(255, 0, 0, 0.5) 0 2px 0;}
    to { background-color: #F00; }
}
@-o-keyframes blinkRed {
    from { background-color: #F00; }
    50% { background-color: #A00; box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #441313 0 -1px 9px, rgba(255, 0, 0, 0.5) 0 2px 0;}
    to { background-color: #F00; }
}
@keyframes blinkRed {
    from { background-color: #F00; }
    50% { background-color: #A00; box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #441313 0 -1px 9px, rgba(255, 0, 0, 0.5) 0 2px 0;}
    to { background-color: #F00; }
}

.led-yellow {
  margin: 0 auto;
  width: 10px;
  height: 10px;
  background-color: #FF0;
  border-radius: 50%;
  /* box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #808002 0 -1px 9px, #FF0 0 2px 12px;
  -webkit-animation: blinkYellow 1s infinite;
  -moz-animation: blinkYellow 1s infinite;
  -ms-animation: blinkYellow 1s infinite;
  -o-animation: blinkYellow 1s infinite;
  animation: blinkYellow 1s infinite; */
}

@-webkit-keyframes blinkYellow {
    from { background-color: #FF0; }
    50% { background-color: #AA0; box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #808002 0 -1px 9px, #FF0 0 2px 0; }
    to { background-color: #FF0; }
}
@-moz-keyframes blinkYellow {
    from { background-color: #FF0; }
    50% { background-color: #AA0; box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #808002 0 -1px 9px, #FF0 0 2px 0; }
    to { background-color: #FF0; }
}
@-ms-keyframes blinkYellow {
    from { background-color: #FF0; }
    50% { background-color: #AA0; box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #808002 0 -1px 9px, #FF0 0 2px 0; }
    to { background-color: #FF0; }
}
@-o-keyframes blinkYellow {
    from { background-color: #FF0; }
    50% { background-color: #AA0; box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #808002 0 -1px 9px, #FF0 0 2px 0; }
    to { background-color: #FF0; }
}
@keyframes blinkYellow {
    from { background-color: #FF0; }
    50% { background-color: #AA0; box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #808002 0 -1px 9px, #FF0 0 2px 0; }
    to { background-color: #FF0; }
}

.led-green {
  margin: 0 auto;
  width: 15px;
  height: 15px;
  background-color: #ABFF00;
  border-radius: 50%;
  /* box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #304701 0 -1px 9px, #89FF00 0 2px 12px; */
}

.deadnet{
  color: #fff;
    font-size: 11px;
    text-transform: uppercase;
    margin-top: 2px;
    margin-right: -7px;
}

.auto-pilot-indicator {
  margin-right: 15px;
}

.robot-icon {
  margin-right: 5px;
}

.robot-icon i {
  font-size: 14px;
  color: white;
}

.countdown {
  margin-left: 5px;
  color: #ABFF00;
}

.no-runs {
  color: #cccccc;
  font-style: italic;
}

.autopilot-run {
  cursor: pointer;
  color: #64b5f6;
  text-decoration: underline;
  transition: color 0.2s ease;
}

.autopilot-run:hover {
  color: #2196f3;
}

.led-gray {
  margin: 0 auto;
  width: 15px;
  height: 15px;
  background-color: #888888;
  border-radius: 50%;
}

.autopilot-message {
  margin-left: 5px;
  color: #cccccc;
  font-style: italic;
}

.animate-robot {
  animation: pulse 1s infinite alternate;
}

@keyframes pulse {
  from { transform: scale(1); opacity: 1; }
  to { transform: scale(1.2); opacity: 0.8; }
}
</style>




// WEBPACK FOOTER //
// AppFooter.vue?6e124363